import { BaseBatchStore } from '../new_base'
import contractitems from './subentities'

export class CItemBatchSetAttrStore extends BaseBatchStore {
  title = 'set basic attributes in batch'
  itemTitle (row) { return row.title }
  overwrite = []

  updateWithBatch (loaded, batch) {
    Object.keys(loaded).forEach(k => {
      const isOverwrite = this.overwrite.includes(k)
      if (batch[k]) {
        if (loaded[k] && loaded[k].length > 0) {
          if (isOverwrite) {
            loaded[k] = batch[k]
          }
        } else {
          loaded[k] = batch[k]
        }
      } else {
        if (isOverwrite) {
          loaded[k] = null
        }
      }
    })
  }
}

export class CItemBatchAddLimitsStore extends BaseBatchStore {
  title = 'add costs in batch'
  limitsstate = this.store.store.createEmbededEntityState(contractitems.limitsAttrs(this.store.store))
  itemTitle (row) { return row.title }

  initNew () {
    const rec = {
      limits: []
    }
    return this.onLoaded(rec)
  }

  updateWithBatch (loaded, batch) {
    loaded.limits = loaded.limits.concat(batch.limits) // concat
  }

  overwrite (loaded, batch) {
    loaded.limits = batch.limits // overwrite
  }
}

export class CItemBatchAddRightsStore extends BaseBatchStore {
  title = 'add rights in batch'
  rightsstate = this.store.store.createEmbededEntityState(
    contractitems.rightsConf(this.store.store, () => 6, true)
  )

  itemTitle (row) { return row.title }

  validators = {
    _global: () => {
      const e = this.store.selectedItems.reduce((acc, i, idx) => {
        const errs = this.record.get('rights').reduce((rightacc, j) => {
          // this loop iterates over rights that is being merged with selection
          // one by one validation with the rest of rights in particular contractitem.rights
          const err = contractitems.validateNotOverlapping(this.store.store, j, i.rights)
          err && rightacc.push(j)
          return rightacc
        }, [])
        errs.length > 0 && acc.push(i)
        return acc
      }, [])
      this.conflictingItems.replace(e.map(i => {
        let fountIdx = null
        this.store.selectedItems.map((j, idx) => {
          if (j.id === i.id) {
            fountIdx = idx
          }
        })
        return fountIdx
      }))
      return e.length > 0 ? e : undefined
    }
  }

  initNew () {
    const rec = {
      rights: []
    }
    return this.onLoaded(rec)
  }

  updateWithBatch (loaded, batch) {
    loaded.rights = loaded.rights.concat(batch.rights) // concat
  }

  overwrite (loaded, batch) {
    loaded.rights = batch.rights // overwrite
  }
}
